<div class="tw-min-w-[200px] xl:tw-min-w-[260px] tw-h-full">
  <mh-data-rate-widget
    [loading]="loading"
    [title]="('followup.summary.emails-pms.title' | translate: {pms: !isHotel ? ('commons.valids' | translate) : 'PMS'})"
    tooltipTitle="followup.summary.data-rate.interchain_tooltip"
    [totalPercentage]="coverageValidDataRate"
    [qualification]="qualificationValidDataRate"
    [items]="[
      { label: ('commons.mails' | translate), percentage: coverageValidDataRateEmail, labelTooltip: 'followup.summary.data-rate.tooltips.mails' },
      { label: ('commons.phones' | translate), percentage: coverageValidDataRatePhone, labelTooltip: 'followup.summary.data-rate.tooltips.phones' }
    ]"
    [showIndicators]="false"
    [productId]="productId"
    [report]="reportValidDataRate"
    [slugReportButton]="reportValidDataRateSlug"
    [dates]="currentDates"
    [heigth]="heigth"
    [second_button_text]="'followup.summary.data-rate.improve_rate'"
    (onSecondButtonClick)="openImproveValidDataRateGuide()"
    (onViewMore)="onViewMore()">
  </mh-data-rate-widget>
</div>
